import React from 'react';
import { ICartlinesViewProps } from '../components/ahi-cart-line-items';

export const ConfigurableCartLineContext = React.createContext<Record<string, ICartlinesViewProps[]>>({});
